import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useStore } from "@/components/Layout";
import { fmtEuro, fmtDate } from "@/lib/status";
import { Card } from "@/components/ui/card";

const STATUS_LABELS = { DRAFT: "Bozza", SENT: "Inviato", APPROVED: "Approvato", REJECTED: "Rifiutato" };
const TABS = [
  { key: "", label: "Tutti" }, { key: "DRAFT", label: "Da inviare" },
  { key: "SENT", label: "In attesa" }, { key: "APPROVED", label: "Approvati" }, { key: "REJECTED", label: "Rifiutati" },
];

export default function Quotes() {
  const { selectedStore } = useStore();
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    api.get("/quotes", { params: { store_id: selectedStore, status: status || undefined } }).then((r) => setRows(r.data));
  }, [selectedStore, status]);

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl">Preventivi</h1>
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.key} data-testid={`quote-tab-${t.key || "all"}`} onClick={() => setStatus(t.key)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium ${status === t.key ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="border-b border-border bg-secondary/50 text-left text-xs uppercase tracking-wider text-muted-foreground">
            <tr><th className="px-4 py-3">N° preventivo</th><th className="px-4 py-3">Versione</th><th className="px-4 py-3">Stato</th><th className="px-4 py-3 text-right">Totale</th><th className="px-4 py-3 hidden sm:table-cell">Creato</th></tr>
          </thead>
          <tbody className="divide-y divide-border">
            {rows.map((q) => (
              <tr key={q.id} data-testid={`quote-row-${q.quote_number}`}>
                <td className="px-4 py-3 font-mono font-semibold text-primary">{q.quote_number}</td>
                <td className="px-4 py-3">v{q.current_version}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-secondary px-2.5 py-0.5 text-xs font-semibold">{STATUS_LABELS[q.status] || q.status}</span></td>
                <td className="px-4 py-3 text-right font-semibold">{fmtEuro(q.total)}</td>
                <td className="px-4 py-3 hidden sm:table-cell text-muted-foreground">{fmtDate(q.created_at)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground">Nessun preventivo.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
